<template>
  <div class="filter-block-range">
    <div class="mb--27">
      משך זמן בלוק:
      <!-- {{ value === 1 ? "שעה" : value + " שעות" }} -->
    </div>
    <div class="slider-wrapper">
      <span class="range-label">6+</span>
      <vue-slider
        :value="value"
        :min="1"
        :max="6"
        :tooltip="'always'"
        :dotSize="16"
        :height="6"
        :interval="0.5"
        @change="value => $emit('input', value)"
      />
      <span class="range-label">1</span>
    </div>
  </div>
</template>

<script>
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/default.css";

export default {
  components: {
    VueSlider
  },
  props: ["value"]
};
</script>
